import "../../styles/components/BButton.css";
const BButton = ({ setStyle='', Icon, children, onClick , disable = false}) => {
  const onEClick = () => {
    if(onClick){
      onClick()
    }
  }
  const cDisable = disable ? 'disable': ''
  return (
    <div className={`BButton ${setStyle} ${cDisable}`} onClick={onEClick}>
      { Icon ? <div className="icon">{Icon}</div> : <></> }
      <button type="button" disabled={disable}>{ children }</button>
    </div>
  )
};
export default BButton;
